function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createEvent, createStore, guard, is, merge, sample, withRegion } from 'effector';
export function combineEvents(_ref) {
  var {
    events,
    reset,
    target = createEvent({
      name: "target",
      sid: "aip3nf"
    }, {
      name: "target",
      sid: "aip3nf"
    })
  } = _ref;
  if (!is.unit(target)) throwError('target should be a unit');
  if (reset && !is.unit(reset)) throwError('reset should be a unit');
  withRegion(target, () => {
    var keys = Object.keys(events);
    var defaultShape = Array.isArray(events) ? [...keys].fill('') : {};
    var $counter = createStore(keys.length, {
      and: {
        serialize: 'ignore'
      },
      name: "$counter",
      sid: "-dby0v3"
    });
    var $results = createStore(defaultShape, {
      and: {
        serialize: 'ignore'
      },
      name: "$results",
      sid: "c60qbe"
    });
    $counter.reset(sample({
      and: [{
        source: target
      }],
      or: {
        sid: "-8hxq8z"
      }
    }));
    $results.reset(target);
    if (reset) {
      $counter.reset(sample({
        and: [{
          source: reset
        }],
        or: {
          sid: "3c6u5p"
        }
      }));
      $results.reset(reset);
    }
    var _loop = function _loop(key) {
      var $isDone = createStore(false, {
        and: {
          serialize: 'ignore'
        },
        name: "$isDone",
        sid: "uttu1j"
      }).on(events[key], () => true).reset(target);
      if (reset) {
        $isDone.reset(reset);
      }
      $counter.on($isDone, value => value - 1);
      $results.on(events[key], (shape, payload) => {
        var newShape = Array.isArray(shape) ? [...shape] : _objectSpread({}, shape);
        newShape[key] = payload;
        return newShape;
      });
    };
    for (var key of keys) {
      _loop(key);
    }
    guard({
      and: [{
        source: sample({
          and: [{
            source: $results,
            clock: merge(Object.values(events), {
              name: "clock",
              sid: "-531esq"
            })
          }],
          or: {
            name: "source",
            sid: "uwap9g"
          }
        }),
        filter: $counter.map(value => value === 0),
        target
      }],
      or: {
        sid: "ciyd7d"
      }
    });
  });
  return target;
}
function throwError(message) {
  throw new Error(message);
}